import React from 'react'
import share from 'assets/share.svg'
import emailDark from 'assets/Social/email_dark.svg'
import linkedinDark from 'assets/Social/linkedin_dark.svg'
import twitterDark from 'assets/Social/twitter_dark.svg'
import emailLight from 'assets/Social/email_light.svg'
import linkedinLight from 'assets/Social/linkedin_filled.svg'
import twitterLight from 'assets/Social/twitter_filled.svg'

export const SocialBar = (props: { dark?: boolean }) => {
  const currentUrl = encodeURIComponent(window.location.href)
  const subject = encodeURIComponent('Check this article out!')

  const handleShareOnTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${currentUrl}&text=${subject}`,
      '_blank',
    )
  }

  const handleShareOnLinkedin = () => {
    window.open(
      `https://linkedin.com/sharing/share-offsite/?url=${currentUrl}`,
      '_blank',
    )
  }

  const handleShareEmail = () => {
    window.location.href = `mailto:?subject=${subject}&body=${currentUrl}`
  }

  const handleShare = () => {
    //
  }

  return (
    <div className='flex gap-2'>
      <button onClick={handleShareOnLinkedin}>
        <img
          src={props.dark ? linkedinDark : linkedinLight}
          className='md:h-6 md:w-6 h-4 w-4'
          alt='Linkedin Icon'
        />
      </button>

      <button onClick={handleShareOnTwitter}>
        <img
          src={props.dark ? twitterDark : twitterLight}
          className='md:h-6 md:w-6 h-4 w-4'
          alt='Twitter Icon'
        />
      </button>

      <button onClick={handleShareEmail}>
        <img
          src={props.dark ? emailDark : emailLight}
          className='md:h-6 md:w-6 h-4 w-4'
          alt='Email Icon'
        />
      </button>

      <button onClick={handleShare}>
        <img src={share} className='md:h-6 md:w-6 h-4 w-4' alt='Share Icon' />
      </button>
    </div>
  )
}
